export default __webpack_public_path__ + "1a5c8142ff1c1de7afb1a7e9047aa306.png";